import React from "react";
import { Plane, MessageCircle, Heart } from "lucide-react";
import PainLandingPage from "@/pages/PainLandingPage";

const LongDistancePage = () => (
  <PainLandingPage
    ns="longDistance"
    variant="gold"
    photo="/assets/lifestyle/couple-hero.jpg"
    icons={[<Plane size={20} />, <MessageCircle size={20} />, <Heart size={20} />]}
  />
);

export default LongDistancePage;
